/*
 * @Author: zhangcongcong zhangcongcong@move2newidea.com
 * @Date: 2023-11-01 14:40:33
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-05-06 16:11:46
 * @FilePath: /memo-web/src/components/memos/sreen.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import { useEffect, useState, useRef } from 'react'
import { tokenDelete } from '../../api/login'
import style from './index.module.css'
import { Button, Select, message } from 'antd'
import { FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons';
import useStore from '../../store/useStore'
import { StorageModule } from "../../modules/storage";

interface Props {
    name?: any,
    showSelect?: any
}

const ModelScreen = (props: Props) => {
    const { store, dispatch } = useStore();
    const [userInfo, setUserInfo] = useState<any>();
    // let selecteVal
    const [selecteVal, setSelecteVal] = useState<any>();
    const [showSelect, setShowSelect] = useState<any>(true);

    useEffect(() => {
        dispatch({
            type: 'GET_TAGMETA',
        });
        setUserInfo(StorageModule.getUser().user);
    }, [])
    useEffect(() => {
        if (props.showSelect === false || store.task_attachment.some((i: any) => i.name == props.name || store.memoOperation.operationType == 'relationBelongTos' || store.memoOperation.operationType == 'comments')) {
            console.log('props.showSelect', props.showSelect)
            setShowSelect(false)
        } else {
            setShowSelect(true)
        }

    }, [props.showSelect, props.name, store.memoOperation.operationType])
    useEffect(() => {
        console.log('selecteVal00', store.myEditMemo, selecteVal)
        let _tagMetaOrg: any = {}
        _tagMetaOrg = store.tagMeta.find((i: any) => i.name == selecteVal)
        console.log('', _tagMetaOrg)
        if (!_tagMetaOrg) return
        dispatch({
            type: 'SET_SELECTTAGMETA',
            data: _tagMetaOrg
        });
        if (!store.memoOperation.isAdd && _tagMetaOrg?.mimeType == "text/webpage" && selecteVal) {
            console.log("网页格式")
        }
        //新建格式便签时，根据选择的格式，将memoInfo的tagMetas信息初始化
        if (store.memoOperation.operationType == 'memos' && store.memoOperation.isAdd && selecteVal) {


            let tagMetas = {
                mimeType: _tagMetaOrg?.mimeType,
                name: _tagMetaOrg?.name,
                notation: _tagMetaOrg?.notation,
                type: _tagMetaOrg?.type,
                instance: {
                }
            }
            if (JSON.stringify(store.myEditMemo?.data) != "{}" && store.myEditMemo?.data?.hasOwnProperty('tagMetas')) {
                tagMetas.instance = {
                    ...store.myEditMemo?.data?.tagMetas[0].instance,
                }
            }
            console.log('selecteVal11', selecteVal, _tagMetaOrg, store.myEditMemo)
            dispatch({
                type: 'SET_MYEDITMEMO',
                data: { ...store.myEditMemo, data: { ...store.myEditMemo.data, tagMetas: [{ ...tagMetas }] } }
            });
            console.log('selecteVal222', store.myEditMemo)
        }
    }, [store.memoOperation.operationType, selecteVal])

    useEffect(() => {
        let _selecteVal
        console.log('store.memoNodesreen', store.memoNode, store.myEditMemo)
        if (store.memoNode) {
            store.replacementMeta.map((i: any) => {
                console.log("i.mimeType,", i.mimeType, store.memoNode.mimeType)
                if (i.mimeType == store.memoNode.mimeType) {
                    _selecteVal = i.name
                } else if (!store.memoNode.mimeType) {
                    _selecteVal = '文本'
                }
            })
            console.log('_selecteVal', _selecteVal)
            setSelecteVal(_selecteVal)
        } else {
            setSelecteVal('文本')
        }
    }, [store.memoNode?.mimeType])
    const openTask = (i: any) => {
        // if ((window as any).graphItem?.getSelectedCells().length == 1) {
        console.log(store.myEditMemo)
        if (JSON.stringify(store.myEditMemo) != '{}' && store.myEditMemo?.data?.id) {
            console.log(i)
            let isOwn: any = store.myEditMemo.data.ownerId === userInfo.id
            console.log(isOwn, store.subjectInfo, store.myEditMemo)
            taskTab(i)
            if (i.notation === 'MarkdownTag' || i.notation === 'ImageTag' || i.notation === 'ImgNotesTag') {
                if ((!isOwn && store.subjectInfo.data.users?.length == 0) || (!isOwn && !store.subjectInfo.data.users)) {
                    message.warning('只能操作自己的markdown格式/图片格式/图片标注类型的便签')
                } else {
                    labelPop(i.mimeType)
                }
            } else {
                dispatch({
                    type: 'SET_TASKVISIBLE',
                    data: true
                });
                // setTaskVisible(true)
            }
        } else {
            message.warning('请选择并且只能选一个便签')
        }

    }
    //标签弹出框类型
    const labelPop = (mimeType: any) => {
        console.log('labelPop', store.tagMeta, mimeType)
        dispatch({
            type: 'SET_LABELPOP',
            data: true
        });

    }
    const taskTab = (i: any) => {
        let info: any = {}
        if (i.name === '任务计划') {
            info = { ...i, label1: '计划完成时间', label2: '预计工时' }
        } else if (i.name === '开始执行') {
            info = { ...i, label1: '预计完成时间', label2: '预计工时' }
        }
        else if (i.name === '任务完成') {
            info = { ...i, label1: '实际完成时间', label2: '实际工时' }
        }
        else if (i.name === '版本计划') {
            info = { ...i, label1: '版本号', }
        }
        else {
            info = { ...i, }
        }
        dispatch({
            type: 'SET_SELECTTAGMETA',
            data: info
        });
    }
    const render = (
        <div data-flex="main:left cross:center">
            <div className='mr-10 cursor icon_hover'
                onClick={() => {
                    dispatch({
                        type: 'SET_MODELFULLSCREEN', data: !store.modelFullScreen
                    });
                }}>
                {store.modelFullScreen ?
                    <FullscreenExitOutlined /> : <FullscreenOutlined />
                }
            </div>
            {(!showSelect && !store.memoOperation.isAdd && (store.selectTagMeta.mimeType == 'application/msword' || store.selectTagMeta.mimeType == 'application/vnd.ms-excel' || store.selectTagMeta.mimeType == 'application/vnd.ms-powerpoint')) && <>编辑</>}
            {showSelect && <>{store.memoOperation.isAdd ? '新建' : '编辑'}</>}{props.name}
            {/* 把任务计划开始执行和注释关系排除出去 */}
            {/* 
            markdown格式切换为文本格式：默认显示memo.content的内容，如果点击确认时仍然是选择文本格式，则保存数据的同时删除memo的格式标签。
markdown格式切换为图片格式：默认显示memo.content的内容(此时编辑器切换成图片编辑器)，如果点击确认时仍然是选择图片格式，则保存数据的同时修改memo的格式标签。
markdown格式切换为图片标注格式：默认显示memo.content的内容(此时编辑器切换成图片标注编辑器的第一步)，如果点击确认时仍然是选择图片标注格式，则保存数据的同时修改memo的格式标签。
图片格式切换为文本格式：默认显示memo.content的内容(此时编辑器切换成文本编辑器)，如果点击确认时仍然是选择文本格式，则保存数据的同时删除memo的格式标签。
图片标注格式切换为文本格式：默认显示memo.content的内容(此时编辑器切换成文本编辑器)，如果点击确认时仍然是选择文本格式，则保存数据的同时删除memo的格式标签并删除标注内容。
图片格式切换为markdown格式：默认显示memo.content的内容，并将图片的链接以markdown链接格式加入memo.content(作为最后一行)，如果点击确认时仍然是选择markdown格式，则保存数据的同时修改memo的格式标签。
图片标注格式切换为markdown格式：默认显示memo.content的内容，并将图片的链接以markdown链接格式追加到memo.content中，在其后以markdown序号列表语法追加标注文本内容(保持序号一致)，如果点击确认时仍然是选择markdown格式，则保存数据的同时修改memo的格式标签并删除标注内容。
图片格式切换为图片标注格式：默认显示memo.content的内容(此时编辑器切换成图片标注编辑器的第一步)，如果点击确认时仍然是选择图片标注格式，则保存数据的同时修改memo的格式标签。
图片标注格式切换为图片格式：默认显示memo.content的内容(此时编辑器切换成图片编辑器)，如果点击确认时仍然是选择图片格式，则保存数据的同时修改memo的格式标签并删除标注内容。
 */}
            {(showSelect) && <Select
                key={'replacement'}
                style={{ width: 120 }}
                className='ml-10 w-150'
                value={selecteVal}
                onMouseLeave={(e) => {
                }}
                onChange={(e: any, tag: any) => {
                    console.log(e, tag)

                    // 关闭其他弹窗
                    dispatch({
                        type: 'SET_CLOSEALL_LABELPOP', data: false
                    });
                    //清除图片标注框
                    dispatch({
                        type: 'SET_IMGNOTESTAG',
                        data: []
                    });

                    dispatch({
                        type: 'SET_CNODE', data: { ...store.memoNode, mimeType: tag.mimeType }
                    });
                    if (tag.mimeType == 'text') {
                        dispatch({
                            type: 'SET_CNODE', data: { ...store.memoNode, mimeType: null }
                        });
                        dispatch({
                            type: 'SET_MEMOMODAL',
                            data: {
                                visible: true,
                                operationType: store.memoOperation.operationType,
                                isAdd: store.memoOperation.isAdd
                            }
                        });
                    } else if (tag.mimeType == 'text/markdown') {
                        dispatch({
                            type: 'SET_MARKDOWNVISIBLE', data: true
                        });
                    } else {
                        setTimeout(() => {
                            dispatch({
                                type: 'SET_LABELPOP',
                                data: true
                            });
                        }, 100);

                    }
                }}
                fieldNames={
                    { label: 'name', value: 'id' }
                }
                options={store.replacementMeta} />}
        </div>
    )
    return render
}

export default ModelScreen
